import { Navigate, Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { RcsWizardLayout } from 'pages/settings/pages/rcsV2/layout/RcsWizardLayout'
import { SenderDetails } from 'pages/settings/pages/rcsV2/pages/create/SenderDetails'
import { Countries } from 'pages/settings/pages/rcsV2/pages/create/Countries'
import { BusinessInfo } from 'pages/settings/pages/rcsV2/pages/create/BusinessInfo'
import { ContactInfo } from 'pages/settings/pages/rcsV2/pages/create/ContactInfo'
import { UseCase } from 'pages/settings/pages/rcsV2/pages/create/UseCase'
import { OptInMessageInfo } from 'pages/settings/pages/rcsV2/pages/create/OptInMessageInfo'
import { Review } from 'pages/settings/pages/rcsV2/pages/create/Review'
import { RcsWizardSteps } from './type'

export const RcsWizardRouter = observer(() => (
  <Routes>
    <Route index element={<Navigate to={RcsWizardSteps.senderDetails} replace />} />
    <Route path={RcsWizardSteps.senderDetails} element={<SenderDetails />} />
    <Route element={<RcsWizardLayout />}>
      <Route path={RcsWizardSteps.countries} element={<Countries />} />
      <Route path={RcsWizardSteps.businessInfo} element={<BusinessInfo />} />
      <Route path={RcsWizardSteps.contactInfo} element={<ContactInfo />} />
      <Route path={RcsWizardSteps.useCase} element={<UseCase />} />
      <Route path={RcsWizardSteps.optInMessageInfo} element={<OptInMessageInfo />} />
      <Route path={RcsWizardSteps.review} element={<Review />} />
      <Route path='*' element={<div>Page Not Found</div>} />
    </Route>
  </Routes>
))
